import { useQuery } from '@tanstack/react-query';
import { parentTuitionBandApi } from '@/features/reports/api/parentTuitionBand.api';

export const parentTuitionBandsQueryKeys = {
  all: ['parentTuitionBands'] as const,
  byYearAndMin: (year: string, min: number) =>
    [...parentTuitionBandsQueryKeys.all, year, 'min', min] as const,
};

/**
 * GET /api/app/parent-tuition-band?Year=…&MinSchoolsPerBand=…
 */
export function useParentTuitionBandsQuery(
  year: string | undefined,
  minSchoolsPerBand: number | null | undefined,
  options?: { enabled?: boolean }
) {
  const y = year?.trim() ?? '';
  const yearNum = Number(y);
  const min =
    minSchoolsPerBand != null && Number.isFinite(minSchoolsPerBand) && minSchoolsPerBand > 0
      ? Math.floor(minSchoolsPerBand)
      : null;
  const baseEnabled = y !== '' && Number.isFinite(yearNum) && min != null;
  const enabled = (options?.enabled ?? true) && baseEnabled;

  return useQuery({
    queryKey: parentTuitionBandsQueryKeys.byYearAndMin(y, min ?? 0),
    queryFn: () =>
      parentTuitionBandApi.getList({
        year: yearNum,
        minSchoolsPerBand: min!,
        skipCount: 0,
        maxResultCount: 1000,
      }),
    enabled,
    staleTime: 60_000,
  });
}
